

// // import React, { useEffect, useRef, useState } from "react";
// // import { useLocation, useNavigate } from "react-router-dom";
// // import { AuthAPI } from "../api/AuthAPI";
// // import { isLoggedIn } from "../utils/auth";

// // export default function DashboardLayout({ children }) {
// //   const navigate = useNavigate();
// //   const location = useLocation();
// //   const drawerRef = useRef(null);

// //   const [user, setUser] = useState(null);
// //   const [loadingUser, setLoadingUser] = useState(true); 

// //   const pathname = normalizePath(location.pathname);

// //   const NAV = [
// //     { key: "overview", label: "Overview", path: "/dashboard" },
// //     {
// //       key: "purchase",
// //       label: "Purchase History",
// //       path: "/dashboard/purchase-history",
// //       hint: "new",
// //     },
// //     { key: "profile", label: "Manage Profile", path: "/dashboard/profile" },
// //     { key: "address", label: "Address", path: "/dashboard/addresses" },
// //   ];

// //   useEffect(() => {
// //     let mounted = true;

// //     async function loadUser() {
// //       if (!isLoggedIn()) {
// //         setLoadingUser(false);
// //         return;
// //       }

// //       try {
// //         const res = await AuthAPI.getMyDetails();
// //         const data = res?.data?.data ?? res?.data;

// //         if (!mounted) return;

// //         setUser({
// //           name: data?.name,
// //           email: data?.email,
// //           image: data?.image || null,
// //         });
// //       } catch (err) {
// //         console.error("Failed to load dashboard user", err);
// //       } finally {
// //         if (mounted) setLoadingUser(false);
// //       }
// //     }

// //     loadUser();

// //     return () => {
// //       mounted = false;
// //     };
// //   }, []);

// //   function navigateTo(path) {
// //     navigate(normalizePath(path));
// //   }

// //   return (
// //     <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-amber-50">
// //       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
// //         <div className="flex items-start gap-8">
// //           {/* ================= PREMIUM SIDEBAR ================= */}

// //           <aside className="hidden md:block w-80 shrink-0">
// //             <div className="sticky top-6">
// //               <div className="overflow-hidden rounded-3xl bg-white border border-gray-100 shadow-xl">
// //                 {/* Profile Header */}

// //                 <div className="relative bg-gradient-to-br from-amber-500 via-orange-500 to-yellow-500 px-6 py-8">
// //                   <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-10 translate-x-10" />
// //                   <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full translate-y-10 -translate-x-10" />

// //                   <div className="relative flex items-center gap-4">
// //                     {user?.image ? (
// //                       <img
// //                         src={user.image}
// //                         alt="profile"
// //                         className="w-16 h-16 rounded-2xl object-cover border-2 border-white/40"
// //                       />
// //                     ) : (
// //                       <div className="w-16 h-16 rounded-2xl bg-white/20 backdrop-blur flex items-center justify-center">
// //                         <UserIcon />
// //                       </div>
// //                     )}

// //                     <div className="text-white min-w-0">
// //                       <h3 className="font-semibold text-lg truncate">
// //                         {loadingUser ? "Loading..." : user?.name || "User"}
// //                       </h3>

// //                       <p className="text-xs text-white/80 truncate">
// //                         {user?.email}
// //                       </p>
// //                     </div>
// //                   </div>
// //                 </div>

// //                 {/* Navigation */}

// //                 <nav className="p-4" ref={drawerRef}>
// //                   <ul className="space-y-2">
// //                     {NAV.map((n) => {
// //                       const navPath = normalizePath(n.path);

// //                       const isActive =
// //                         pathname === navPath ||
// //                         (n.key !== "overview" &&
// //                           pathname.startsWith(navPath + "/"));

// //                       return (
// //                         <li key={n.key}>
// //                           <button
// //                             type="button"
// //                             onClick={() => navigateTo(navPath)}
// //                             className={`group relative w-full flex items-center gap-4 px-4 py-3 rounded-2xl transition-all duration-300
// //                             ${
// //                               isActive
// //                                 ? "bg-gradient-to-r from-orange-500 to-amber-500 text-white shadow-lg"
// //                                 : "hover:bg-gray-50 text-gray-700"
// //                             }`}
// //                           >
// //                             {isActive && (
// //                               <span className="absolute left-0 top-3 bottom-3 w-1 rounded-r-full bg-white" />
// //                             )}

// //                             <span
// //                               className={`text-lg transition-transform duration-300 group-hover:scale-110 ${
// //                                 isActive ? "text-white" : "text-gray-500"
// //                               }`}
// //                             >
// //                               {navIcon(n.key)}
// //                             </span>

// //                             <span className="flex-1 text-left font-medium">
// //                               {n.label}
// //                             </span>

// //                             {n.hint && (
// //                               <span className="text-[10px] uppercase font-semibold px-2 py-1 rounded-full bg-white/20">
// //                                 {n.hint}
// //                               </span>
// //                             )}
// //                           </button>
// //                         </li>
// //                       );
// //                     })}
// //                   </ul>
// //                 </nav>

// //                 {/* Footer Card */}

// //                 {/* <div className="p-4 border-t border-gray-100">
// //                   <div className="rounded-2xl bg-gradient-to-r from-slate-900 to-slate-700 p-4 text-white">
// //                     <p className="text-xs uppercase tracking-wider text-slate-300">
// //                       Customer Panel
// //                     </p>

// //                     <h4 className="font-semibold mt-1">Premium Experience</h4>

// //                     <p className="text-xs text-slate-400 mt-1">
// //                       Manage your profile, purchases and addresses.
// //                     </p>
// //                   </div>
// //                 </div> */}
// //               </div>
// //             </div>
// //           </aside>

// //           {/* ================= MAIN CONTENT ================= */}

// //           <main className="flex-1 min-w-0">
// //             <div className="space-y-6">{children}</div>
// //           </main>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // /* ================= HELPERS ================= */

// // function normalizePath(p) {
// //   if (!p) return "/";
// //   return p === "/" ? "/" : p.replace(/\/+$/, "");
// // }

// // /* ================= ICONS ================= */

// // function navIcon(key) {
// //   switch (key) {
// //     case "overview":
// //       return "🏠";

// //     case "purchase":
// //       return "🧾";

// //     case "profile":
// //       return "👤";

// //     case "address":
// //       return <LocationIcon />;

// //     default:
// //       return "•";
// //   }
// // }

// // function UserIcon() {
// //   return (
// //     <svg
// //       className="w-7 h-7 text-white"
// //       viewBox="0 0 24 24"
// //       fill="none"
// //       stroke="currentColor"
// //       strokeWidth="1.8"
// //     >
// //       <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z" />
// //       <path d="M6 20a6 6 0 0112 0" />
// //     </svg>
// //   );
// // }

// // function LocationIcon() {
// //   return (
// //     <svg
// //       className="w-5 h-5"
// //       viewBox="0 0 24 24"
// //       fill="none"
// //       stroke="currentColor"
// //       strokeWidth="1.8"
// //       strokeLinecap="round"
// //       strokeLinejoin="round"
// //     >
// //       <path d="M12 21s-6-5-6-10a6 6 0 1 1 12 0c0 5-6 10-6 10z" />
// //       <circle cx="12" cy="11" r="2.5" />
// //     </svg>
// //   );
// // }














// import React, { useEffect, useRef, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { AuthAPI } from "../api/AuthAPI";
// import { isLoggedIn } from "../utils/auth";

// export default function DashboardLayout({ children }) {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const drawerRef = useRef(null);

//   const [user, setUser] = useState(null);
//   const [loadingUser, setLoadingUser] = useState(true);

//   const pathname = normalizePath(location.pathname);

//   const NAV = [
//     { key: "overview", label: "Overview", path: "/dashboard" },
//     {
//       key: "purchase",
//       label: "Purchase History",
//       path: "/dashboard/purchase-history",
//       hint: "new",
//     },

//     { key: "address", label: "Address", path: "/dashboard/addresses" },
//         { key: "profile", label: "Manage Profile", path: "/dashboard/profile" },
//   ];

//   useEffect(() => {
//     let mounted = true;

//     async function loadUser() {
//       if (!isLoggedIn()) {
//         setLoadingUser(false);
//         return;
//       }

//       try {
//         const res = await AuthAPI.getMyDetails();
//         const data = res?.data?.data ?? res?.data;

//         if (!mounted) return;

//         setUser({
//           name: data?.name,
//           email: data?.email,
//           image: data?.image || null,
//         });
//       } catch (err) {
//         console.error("Failed to load dashboard user", err);
//       } finally {
//         if (mounted) setLoadingUser(false);
//       }
//     }

//     loadUser();

//     return () => {
//       mounted = false;
//     };
//   }, []);

//   function navigateTo(path) {
//     navigate(normalizePath(path));
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-pink-50">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//         <div className="flex items-start gap-8">
//           {/* ================= PREMIUM SIDEBAR ================= */}

//           <aside className="hidden md:block w-80 shrink-0">
//             <div className="sticky top-6">
//               <div className="overflow-hidden rounded-3xl bg-white border border-gray-100 shadow-xl">
//                 {/* Profile Header */}

//                 <div className="relative bg-gradient-to-br from-pink-500 via-fuchsia-500 to-blue-500 px-6 py-8">
//                   <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-10 translate-x-10" />
//                   <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full translate-y-10 -translate-x-10" />

//                   <div className="relative flex items-center gap-4">
//                     {user?.image ? (
//                       <img
//                         src={user.image}
//                         alt="profile"
//                         className="w-16 h-16 rounded-2xl object-cover border-2 border-white/40"
//                       />
//                     ) : (
//                       <div className="w-16 h-16 rounded-2xl bg-white/20 backdrop-blur flex items-center justify-center">
//                         <UserIcon />
//                       </div>
//                     )}

//                     <div className="text-white min-w-0">
//                       <h3 className="font-semibold text-lg truncate">
//                         {loadingUser ? "Loading..." : user?.name || "User"}
//                       </h3>

//                       <p className="text-xs text-white/80 truncate">
//                         {user?.email}
//                       </p>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Navigation */}

//                 <nav className="p-4" ref={drawerRef}>
//                   <ul className="space-y-2">
//                     {NAV.map((n) => {
//                       const navPath = normalizePath(n.path);

//                       const isActive =
//                         pathname === navPath ||
//                         (n.key !== "overview" &&
//                           pathname.startsWith(navPath + "/"));

//                       return (
//                         <li key={n.key}>
//                           <button
//                             type="button"
//                             onClick={() => navigateTo(navPath)}
//                             className={`group relative w-full flex items-center gap-4 px-4 py-3 rounded-2xl transition-all duration-300
//                             ${
//                               isActive
//                                 ? "bg-gradient-to-r from-blue-500 to-pink-500 text-white shadow-lg"
//                                 : "hover:bg-gray-50 text-gray-700"
//                             }`}
//                           >
//                             {isActive && (
//                               <span className="absolute left-0 top-3 bottom-3 w-1 rounded-r-full bg-white" />
//                             )}

//                             <span
//                               className={`text-lg transition-transform duration-300 group-hover:scale-110 ${
//                                 isActive ? "text-white" : "text-gray-500"
//                               }`}
//                             >
//                               {navIcon(n.key)}
//                             </span>

//                             <span className="flex-1 text-left font-medium">
//                               {n.label}
//                             </span>

//                             {n.hint && (
//                               <span className="text-[10px] uppercase font-semibold px-2 py-1 rounded-full bg-white/20">
//                                 {n.hint}
//                               </span>
//                             )}
//                           </button>
//                         </li>
//                       );
//                     })}
//                   </ul>
//                 </nav>
//               </div>
//             </div>
//           </aside>

//           {/* ================= MAIN CONTENT ================= */}

//           <main className="flex-1 min-w-0">
//             <div className="space-y-6">{children}</div>
//           </main>
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ================= HELPERS ================= */

// function normalizePath(p) {
//   if (!p) return "/";
//   return p === "/" ? "/" : p.replace(/\/+$/, "");
// }

// /* ================= ICONS ================= */

// function navIcon(key) {
//   switch (key) {
//     case "overview":
//       return "🏠";

//     case "purchase":
//       return "🧾";

//     case "profile":
//       return "👤";

//     case "address":
//       return <LocationIcon />;

//     default:
//       return "•";
//   }
// }

// function UserIcon() {
//   return (
//     <svg
//       className="w-7 h-7 text-white"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="1.8"
//     >
//       <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z" />
//       <path d="M6 20a6 6 0 0112 0" />
//     </svg>
//   );
// }

// function LocationIcon() {
//   return (
//     <svg
//       className="w-5 h-5"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="1.8"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       <path d="M12 21s-6-5-6-10a6 6 0 1 1 12 0c0 5-6 10-6 10z" />
//       <circle cx="12" cy="11" r="2.5" />
//     </svg>
//   );
// }



















import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  LayoutGrid,
  Package,
  Truck,
  UserRound,
  MapPin,
  CreditCard,
  RotateCcw,
  Heart,
  LogOut,
} from "lucide-react";
import { AuthAPI } from "../api/AuthAPI";
import { isLoggedIn, logout } from "../utils/auth";

export default function DashboardLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  const [user, setUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);

  const pathname = normalizePath(location.pathname);

  const NAV = [
    { key: "overview", label: "Dashboard", path: "/dashboard", icon: LayoutGrid },
    { key: "orders", label: "My Orders", path: "/dashboard/purchase-history", icon: Package },
    { key: "track", label: "Track Orders", path: "/dashboard/track-orders", icon: Truck },
    
    { key: "address", label: "Addresses", path: "/dashboard/addresses", icon: MapPin },
    { key: "payments", label: "Payments", path: "/dashboard/payments", icon: CreditCard },
    { key: "profile", label: "Personal Info", path: "/dashboard/profile", icon: UserRound },
    // { key: "refunds", label: "Refund Orders", path: "/dashboard/refund-orders", icon: RotateCcw },
    // { key: "wishlist", label: "Wishlist", path: "/dashboard/wishlist", icon: Heart },
  ];

  useEffect(() => {
    let mounted = true;

    async function loadUser() {
      if (!isLoggedIn()) {
        setLoadingUser(false);
        return;
      }

      try {
        const res = await AuthAPI.getMyDetails();
        const data = res?.data?.data ?? res?.data;

        if (!mounted) return;

        setUser({
          name: data?.name,
          phone: data?.phone,
          email: data?.email,
          image: data?.image || null,
        });
      } catch (err) {
        console.error("Failed to load dashboard user", err);
      } finally {
        if (mounted) setLoadingUser(false);
      }
    }

    loadUser();

    return () => {
      mounted = false;
    };
  }, []);

  function navigateTo(path) {
    navigate(normalizePath(path));
  }

  function handleLogout() {
    logout?.();
    navigate("/");
  }

  const displayName = user?.name || user?.phone || "User";
  const displaySub = user?.email || user?.phone || "";
  const initial = displayName?.charAt(0)?.toUpperCase() || "U";

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex items-start gap-6">
          {/* ================= SIDEBAR (DESKTOP) ================= */}
          <aside className="hidden md:block w-72 shrink-0">
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
              {/* USER HEADER */}
              <div className="bg-gray-900 px-6 py-8 flex flex-col items-center text-center">
                {user?.image ? (
                  <img
                    src={user.image}
                    alt="profile"
                    className="w-16 h-16 rounded-full object-cover border-2 border-white/20"
                  />
                ) : (
                  <div className="w-16 h-16 rounded-full bg-pink-500 text-white text-xl font-bold flex items-center justify-center">
                    {initial}
                  </div>
                )}

                <div className="mt-3 text-white font-semibold text-sm truncate max-w-full">
                  {loadingUser ? "Loading..." : displayName}
                </div>

                {displaySub && (
                  <div className="text-gray-400 text-xs mt-1 truncate max-w-full">
                    {displaySub}
                  </div>
                )}
              </div>

              {/* NAVIGATION */}
              <nav className="p-3">
                <ul className="space-y-1">
                  {NAV.map((n) => {
                    const navPath = normalizePath(n.path);
                    const Icon = n.icon;

                    const isActive =
                      pathname === navPath ||
                      (n.key !== "overview" && pathname.startsWith(navPath + "/"));

                    return (
                      <li key={n.key}>
                        <button
                          type="button"
                          onClick={() => navigateTo(navPath)}
                          className={`w-full text-left flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                            isActive
                              ? "bg-pink-50 text-gray-900"
                              : "text-gray-600 hover:bg-gray-50"
                          }`}
                        >
                          <Icon
                            size={17}
                            className={isActive ? "text-pink-600" : "text-gray-400"}
                          />
                          <span className="flex-1">{n.label}</span>
                        </button>
                      </li>
                    );
                  })}
                </ul>

                {/* LOGOUT */}
                <div className="border-t border-gray-100 mt-3 pt-3">
                  <button
                    type="button"
                    onClick={handleLogout}
                    className="w-full text-left flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium text-red-500 hover:bg-red-50 transition-colors"
                  >
                    <LogOut size={17} />
                    <span>Logout</span>
                  </button>
                </div>
              </nav>
            </div>
          </aside>

          {/* ================= MAIN CONTENT ================= */}
          <main className="flex-1 min-w-0">
            <div className="space-y-6">{children}</div>
          </main>
        </div>
      </div>
    </div>
  );
}

/* ================= HELPERS ================= */

function normalizePath(p) {
  if (!p) return "/";
  return p === "/" ? "/" : p.replace(/\/+$/, "");
}